/**
 * LinkedIn Insight Tag — solo para páginas públicas.
 *
 */
const LINKEDIN_PARTNER_ID = '9798874'
const LINKEDIN_SCRIPT_SRC = 'https://snap.licdn.com/li.lms-analytics/insight.min.js'

export const LINKEDIN_CONVERSIONS = {
  CITA_AGENDADA: 31046946,
}

// En el prerender (build) no se inyecta: el <script> quedaría congelado en el HTML estático
const isPrerender = () => Boolean(window.__PRERENDER_INJECTED?.isPrerender)

const isEnabled = () => process.env.VUE_APP_LINKEDIN_INSIGHT_ENABLED === 'true' && !isPrerender()

// Bandera propia del módulo: no depender de window._linkedin_partner_id
let loaded = false

export const isLinkedinInsightLoaded = () => loaded

export const loadLinkedinInsight = () => {
  if (!isEnabled() || loaded) return
  loaded = true

  window._linkedin_partner_id = LINKEDIN_PARTNER_ID
  window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || []
  window._linkedin_data_partner_ids.push(LINKEDIN_PARTNER_ID)

  if (!window.lintrk) {
    window.lintrk = function lintrk(a, b) { window.lintrk.q.push([a, b]) }
    window.lintrk.q = []
  }

  const script = document.createElement('script')
  script.type = 'text/javascript'
  script.async = true
  script.src = LINKEDIN_SCRIPT_SRC
  document.head.appendChild(script)
}

/** Solo registra si el tag está cargado (ruta pública + ambiente habilitado). */
export const trackLinkedinConversion = (conversionId) => {
  if (!isLinkedinInsightLoaded() || typeof window.lintrk !== 'function') return
  window.lintrk('track', { conversion_id: conversionId })
}
